<div>
  <div
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (click)="fileInput.click()"
    [ngClass]="{
      'bg-proffeo-surface-selected': dropZoneActive,
      'rounded-2xl border border-dashed': mode() === 'filedrop'
    }"
    class="group cursor-pointer transition-all duration-200 ease-in-out"
  >
    <input
      #fileInput
      (cancel)="cancelHandler($event)"
      (change)="fileBrowseHandler($event)"
      type="file"
      id="fileDropRef"
      multiple
      class="hidden"
    />

    @if (mode() === 'ngContent') {
      <div class="flex h-full w-full items-center">
        <ng-content></ng-content>
      </div>
    } @else {
      @if (mode() === 'filedrop') {
        <div
          [ngClass]="{
            'border-proffeo-accent bg-proffeo-accent/50 shadow-lg': dropZoneActive,
            'border-proffeo-surface-off bg-proffeo-surface-muted': !dropZoneActive
          }"
          class="flex w-full items-center bg-proffeo-surface justify-center gap-3.5 rounded-2xl border-dashed p-2 md:p-4 transition-all duration-300 lg:h-[104px] lg:gap-5 lg:px-4 lg:py-8"
        >
          <mat-icon
            [ngClass]="{
              'icon-accent drop-shadow-lg pointer-events-none': dropZoneActive,
              'icon-disabled': !dropZoneActive
            }"
            fontIcon="attach_file_add"
            class="transition-all duration-300 icon-xl"
          />
          <div
            [ngClass]="{
              'text-proffeo-accent-700 pointer-events-none': dropZoneActive,
              'text-proffeo-muted': !dropZoneActive
            }"
            class="flex flex-col gap-1 transition-all duration-300"
          >
            <div class="w-full flex-col gap-1 hidden sm:flex">
              <p>
                {{ 'files-drag-and-drop-title' | translate }}
              </p>
              <p>
                {{ 'files-drag-and-drop-or' | translate }}
                <span class="font-semibold underline">
                  {{ 'files-drag-and-drop-upload-button' | translate }}
                </span>
              </p>
            </div>
            <p class="flex sm:hidden">
              {{ 'files-drag-and-drop-upload-button' | translate }}
            </p>
          </div>
        </div>
      }

      @if (mode() === 'thumbnail') {
        <div class="flex flex-col items-center justify-center gap-2 p-2 cursor-pointer">
          <div class="flex flex-row items-center justify-center">
            <proffeo-ui-button
              [iconSize]="ProffeoUiIconSize.BASE"
              fontIcon="photo_camera"
              class="p-auto"
            ></proffeo-ui-button>
          </div>
        </div>
      }

      @if (mode() === 'icon') {
        <div class="flex items-center justify-center p-2">
          <mat-icon
            [ngClass]="{ 'icon-accent drop-shadow-lg': dropZoneActive }"
            fontIcon="attach_file"
            class="cursor-pointer text-3xl transition-all duration-300"
          />
        </div>
      }

      @if (mode() === 'button') {
        <button
          class="bg-proffeo-accent cursor-pointer rounded-full px-4 py-2 text-center font-semibold transition-transform hover:scale-90"
        >
          {{ 'files-drag-and-drop-upload-button' | translate }}
        </button>
      }
    }
  </div>
</div>
